import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

import { Field, Checkbox, Icon, Flexer, Spacer } from '@ontruck/orc';
import VehicleImage from 'components/VehicleImage';
import { CarrierDriverFilter } from 'components/ShipmentFilters';
import { StyledSelect } from './styled';

import LastJobDateFilter from './individual-filters/LastJobDateFilter';
import PostalCodeFilter from './individual-filters/PostalCodeFilter';
import { reactSelectStyles } from 'utils/style';
import {
  VEHICLE_ENGINE_TYPES,
  VEHICLE_EURO_CATEGORIES,
} from 'components/CarrierVehicleEditModal/constants.js';
import Select from 'react-select-v3';
import styles from 'modules/vehicle-section/VehicleList/List/style.module.scss';

const ColorBackgroundWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 98;
  background: var(--primary-filters);
  color: var(--primary-top-bar-color);
  padding: 8px 14px;
`;
class VehicleFilters extends Component {
  render() {
    const {
      disabled,
      query,
      routes,
      handleChangeFilter,
      handleChangeFilterCheckbox,
      handleChangeFilterMulti,
    } = this.props;

    const {
      date,
      carrierName,
      carrier,
      route,
      pallets,
      weight,
      height,
      width,
      postalcode,
      needs_lateral_loading,
      needs_liftgate,
      needs_top_load,
      needs_van,
      needs_box_van,
      needs_rigid_truck,
      needs_semi_or_full_trailer,
      needs_trailer,
      euro_category,
      engine_type,
    } = query;

    const t = {
      any_route: 'Any',
      select_route: 'Route',
      pallets: 'Pallets',
      weight: 'Weight',
      height: 'Height',
      width: 'Width',
      inactive_carrier: 'Search vehicles from inactive carriers',
      plate_number: 'Plate Number',
      carrier_filter_placeholder: 'Carrier',
      engine_type: 'Engine Type',
      euro_category: 'Euro Category (greater than)',
      euro_category_label: 'Euro Category',
    };

    const mappedRoutes = [{ value: 'any', label: t.any_route }].concat(
      routes.map((route) => ({ value: route.name, label: route.simple_name }))
    );

    const findOptionByValue = (value, options) =>
      options.find((option) => option.value === value) || {};

    const getMultiOptions = (optionsString, options) =>
      optionsString?.split(',').map((value) => findOptionByValue(value, options)) || [];

    return (
      <ColorBackgroundWrapper>
        <Flexer.Parent justifyContent="space-between" data-testid="vehicle-filters">
          <Flexer.Parent flexDirection="column">
            <Flexer.Parent mBottom="S">
              <Spacer mRight="M">
                <StyledSelect
                  placeholder={t.select_route}
                  ignoreCase={true}
                  matchPos="any"
                  value={route}
                  disabled={disabled}
                  options={mappedRoutes.map(({ value, label }) => ({ value, label }))}
                  onChange={(option) => handleChangeFilter('route')(option.value)}
                  clearable={false}
                  small
                />
              </Spacer>
              <CarrierDriverFilter
                stylingProps={{ minWidth: '150px' }}
                placeholder={t.carrier_filter_placeholder}
                onChange={(change) => {
                  if (!change) {
                    handleChangeFilter(['carrier', 'carrierName'])(['', '']);
                    return;
                  }

                  const { value } = change;
                  const { id, name, carrier_id, contact_name } = value;

                  handleChangeFilter(['carrier', 'carrierName'])(
                    carrier_id ? [carrier_id, contact_name] : [id, name]
                  );
                }}
                carrier={carrier ? { label: carrierName, value: carrier } : null}
              />
              <Spacer mRight="M">
                <LastJobDateFilter value={date} handleChangeFilter={handleChangeFilter} />
              </Spacer>
              <PostalCodeFilter value={postalcode} handleChangeFilter={handleChangeFilter} />
            </Flexer.Parent>

            <Flexer.Parent mBottom="S">
              <Flexer.Parent justifyContent="space-between" alignItems="center" mRight="M">
                <Spacer mRight="XS">
                  <Icon size="1.5rem" glyph="width" color="grey500" />
                </Spacer>
                <Spacer mRight="XS">
                  <b>Width &nbsp;</b>
                </Spacer>
                <Field
                  label={t.width}
                  value={width || ''}
                  onChange={(e, { value }) =>
                    handleChangeFilter('width')((value || '').replace(',', '.'))
                  }
                  disabled={disabled}
                  asideRightText={t.meters}
                  width="S"
                />
              </Flexer.Parent>

              <Flexer.Parent justifyContent="space-between" alignItems="center">
                <Spacer mRight="XS">
                  <Icon size="1.5rem" glyph="weight" color="grey500" />
                </Spacer>
                <Spacer mRight="XS">
                  <b>Weight</b>
                </Spacer>
                <Field
                  label={t.weight}
                  value={weight || ''}
                  onChange={(e, { value }) =>
                    handleChangeFilter('weight')((value || '').replace(',', '.'))
                  }
                  disabled={disabled}
                  asideRightText={t.kg}
                  width="S"
                />
              </Flexer.Parent>

              <Flexer.Parent
                justifyContent="space-between"
                alignItems="center"
                data-testid="vehicle-filters__euro_category"
              >
                <Spacer mRight="XS" mLeft="M">
                  <label htmlFor="euro_category" className={styles.bold}>
                    {t.euro_category}
                  </label>
                </Spacer>
                <Select
                  inputId="euro_category"
                  name="euro_category"
                  options={[...VEHICLE_EURO_CATEGORIES, { label: 'Any', value: 'ANY' }]}
                  onChange={(selectedOption) =>
                    handleChangeFilter('euro_category')(selectedOption?.value)
                  }
                  styles={reactSelectStyles}
                  containerWidth="auto"
                  placeholder={t.euro_category_label}
                  value={findOptionByValue(euro_category, VEHICLE_EURO_CATEGORIES) || undefined}
                />
              </Flexer.Parent>
            </Flexer.Parent>

            <Flexer.Parent>
              <Flexer.Parent justifyContent="space-between" alignItems="center" mRight="M">
                <Spacer mRight="XS">
                  <Icon size="1.5rem" glyph="height2" color="grey500" />
                </Spacer>
                <Spacer mRight="XS">
                  <b>Height</b>
                </Spacer>
                <Field
                  label={t.height}
                  value={height || ''}
                  onChange={(e, { value }) =>
                    handleChangeFilter('height')((value || '').replace(',', '.'))
                  }
                  disabled={disabled}
                  asideRightText={t.meters}
                  width="S"
                />
              </Flexer.Parent>

              <Flexer.Parent justifyContent="space-between" alignItems="center">
                <Spacer mRight="XS">
                  <Icon size="1.5rem" glyph="boxes" color="grey500" />
                </Spacer>
                <Spacer mRight="XS">
                  <b>Pallets</b>
                </Spacer>
                <Field
                  label={t.pallets}
                  value={(pallets && String(pallets)) || ''}
                  onChange={(e, { value }) => handleChangeFilter('pallets')(Number(value))}
                  disabled={disabled}
                  width="S"
                />
              </Flexer.Parent>

              <Flexer.Parent
                justifyContent="space-between"
                alignItems="center"
                fullWidth
                data-testid="vehicle-filters__engine_type"
              >
                <Spacer mRight="XS" mLeft="M">
                  <label htmlFor="engine_type" className={styles.bold}>
                    {t.engine_type}
                  </label>
                </Spacer>
                <Select
                  inputId="engine_type"
                  name="engine_type"
                  options={VEHICLE_ENGINE_TYPES}
                  placeholder={t.engine_type}
                  isMulti
                  onChange={(selectedOptions) =>
                    handleChangeFilterMulti('engine_type')(selectedOptions)
                  }
                  styles={reactSelectStyles}
                  containerWidth="auto"
                  value={getMultiOptions(engine_type, VEHICLE_ENGINE_TYPES) || []}
                />
              </Flexer.Parent>
            </Flexer.Parent>
          </Flexer.Parent>

          <Flexer.Parent flexDirection="column">
            <Flexer.Parent justifyContent="flex-end" mBottom="S">
              <Checkbox
                contracted
                girded
                label={<VehicleImage type={'van'} />}
                checked={!!needs_van}
                onChange={handleChangeFilterCheckbox('needs_van')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<VehicleImage type={'box_van'} />}
                checked={!!needs_box_van}
                onChange={handleChangeFilterCheckbox('needs_box_van')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<VehicleImage type={'rigid_truck'} />}
                checked={!!needs_rigid_truck}
                onChange={handleChangeFilterCheckbox('needs_rigid_truck')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<VehicleImage type={'semi_trailer'} />}
                checked={!!needs_semi_or_full_trailer}
                onChange={handleChangeFilterCheckbox('needs_semi_or_full_trailer')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<VehicleImage type={'trailer'} />}
                checked={!!needs_trailer}
                onChange={handleChangeFilterCheckbox('needs_trailer')}
                disabled={disabled}
              />
            </Flexer.Parent>

            <Flexer.Parent justifyContent="flex-end">
              <Checkbox
                contracted
                girded
                label={<Icon size="3rem" glyph="extras-liftgate" color="grey500" />}
                checked={!!needs_liftgate}
                onChange={handleChangeFilterCheckbox('needs_liftgate')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<Icon size="3rem" glyph="extras-sideload" color="grey500" />}
                checked={!!needs_lateral_loading}
                onChange={handleChangeFilterCheckbox('needs_lateral_loading')}
                disabled={disabled}
              />
              <Checkbox
                contracted
                girded
                label={<Icon size="3rem" glyph="extras-retractableroof" color="grey500" />}
                checked={!!needs_top_load}
                onChange={handleChangeFilterCheckbox('needs_top_load')}
                disabled={disabled}
              />
            </Flexer.Parent>
          </Flexer.Parent>
        </Flexer.Parent>
      </ColorBackgroundWrapper>
    );
  }
}

VehicleFilters.propTypes = {
  intl: PropTypes.any,
  onChangeFilter: PropTypes.func,
  routes: PropTypes.array,
  status: PropTypes.object,
  disabled: PropTypes.bool,
};

export default VehicleFilters;
